import { PriorityLevel, QueuePriority, TicketState } from '../../enums';
// State

export interface IState {
    locationStatus: ILocationStatus;
    queues: IQueue[];
    services: IServiceStatistic[];
}

export interface ILocationStatus {
    assignedTicket: ITicket | null;
}

export interface IService {
    id: number;
    count: number | 0;
    name: string | null;
}

export interface IServiceStatistic {
    id: string;
    count: number | 0;
    name: string | null;
    groupId: number | null;
}

export interface IQueue {
    id: number;
    name: string | null;
    tickets: ITicket[];
    isSelectedInLocation: boolean;
}

export interface ITicket {
    id: number;
    number: string;
    serviceId: number | null;
    serviceName: string;
    patientFirstName: string;
    patientLastName: string;
    modifiedAt: string;
    visitTime: string | null;
    visitDate: string | null;
    terminalServiceId: number | null;
    state: TicketState | number;
    queueId: number | null;
    priorityLevel: PriorityLevel | number;
    queuePriorityLevel: QueuePriority | number;
    invitingTicketLocationId: number | null;
}

// Action types

export const LOAD_LOCATION_STATUS = 'queueManagement/LOAD_LOCATION_STATUS';
export const LOAD_QUEUES = 'queueManagement/LOAD_QUEUES';
export const REPLACE_QUEUE = 'queueManagement/REPLACE_QUEUE';
export const ADD_TICKET = 'queueManagement/ADD_TICKET';
export const ASSIGN_TICKET = 'queueManagement/ASSIGN_TICKET';
export const REMOVE_TICKET_FROM_QUEUE = 'queueManagement/REMOVE_TICKET_FROM_QUEUE';
export const REMOVE_ASSIGNED_TICKET = 'queueManagement/REMOVE_ASSIGNED_TICKET';
export const LOAD_SERVICES = 'queueManagement/LOAD_SERVICES';
export const UPDATE_SERVICE = 'queueManagement/UPDATE_SERVICE';
export const UPDATE_TICKET_STATE = 'queueManagement/UPDATE_TICKET_STATE';
export const UPDATE_TICKET_STATE_OR_ADD_TO_QUEUE = 'queueManagement/UPDATE_TICKET_STATE_OR_ADD_TO_QUEUE';

export const actions = {
    loadLoactionStatus: (locationStatus: ILocationStatus) => ({
        type: LOAD_LOCATION_STATUS as typeof LOAD_LOCATION_STATUS,
        payload: locationStatus
    }),
    loadQueues: (queues: IQueue[]) => ({
        type: LOAD_QUEUES as typeof LOAD_QUEUES,
        payload: queues
    }),
    replaceQueues: (queue: IQueue) => ({
        type: REPLACE_QUEUE as typeof REPLACE_QUEUE,
        payload: queue
    }),
    loadServices: (services: IServiceStatistic[]) => ({
        type: LOAD_SERVICES as typeof LOAD_SERVICES,
        payload: services
    }),
    updateService: (service: IServiceStatistic) => ({
        type: UPDATE_SERVICE as typeof UPDATE_SERVICE,
        payload: service
    }),
    assignTicket: (ticket: ITicket, locationId: number | null) => ({
        type: ASSIGN_TICKET as typeof ASSIGN_TICKET,
        payload: {
            ticket: ticket,
            locationId: locationId
        }
    }),
    addTicketToQueue: (ticket: ITicket, isRemoveNeeded: boolean) => ({
        type: ADD_TICKET as typeof ADD_TICKET,
        payload: {
            ticket: ticket,
            isRemoveNeeded: isRemoveNeeded
        }
    }),
    removeTicketFromQueue: (ticketId: number) => ({
        type: REMOVE_TICKET_FROM_QUEUE as typeof REMOVE_TICKET_FROM_QUEUE,
        payload: {
            ticketId: ticketId
        }
    }),

    removeAssignedTicket: (ticketId: number | null) => ({
        type: REMOVE_ASSIGNED_TICKET as typeof REMOVE_ASSIGNED_TICKET,
        payload: {
            ticketId: ticketId
        }
    }),

    updateTicketState: (ticketId: number, newState: TicketState) => ({
        type: UPDATE_TICKET_STATE as typeof UPDATE_TICKET_STATE,
        payload: {
            ticketId: ticketId,
            newState: newState
        }
    }),

    updateTicketStateOrAddToQueue: (ticket: ITicket, newState: TicketState) => ({
        type: UPDATE_TICKET_STATE_OR_ADD_TO_QUEUE as typeof UPDATE_TICKET_STATE_OR_ADD_TO_QUEUE,
        payload: {
            ticket: ticket,
            newState: newState
        }
    })
};

export type ActionTypes = ActionUnion<typeof actions>;
